// extracted by mini-css-extract-plugin
module.exports = {"banner":"styles_banner__mRN_C","text":"styles_text__EJQ9k","skeleton-animation":"styles_skeleton-animation___Vjq_","info":"styles_info__11Wsq"};